import React from "react";
import { useTranslation } from "react-i18next";
import PageHead from "@/components/PageHead";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const sections = Array.from({ length: 11 }, (_, i) => i + 1);
  return (
    <>
      <PageHead titleKey="meta.privacy.title" descriptionKey="meta.privacy.description" />
      <section className="ag-section ag-legal">
        <div className="ag-container ag-legal__inner">
          <span className="ag-eyebrow">{t("nav.privacy")}</span>
          <h1 className="ag-h1">{t("privacy.title")}</h1>
          <p className="ag-legal__updated">{t("privacy.updated")}</p>
          <p className="ag-legal__intro">{t("privacy.intro")}</p>
          {sections.map((n) => (
            <div className="ag-legal__section" key={n}>
              <h2>{t(`privacy.s${n}Title`)}</h2>
              <p>{t(`privacy.s${n}Body`)}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
